<template >
  <base-dialog-form :type="type" ref="editAssociazioneDialog" :title="computedTitle" color="secondary" icon="mdi-bank">
    <template v-slot:actions v-if="method !== 'VIEW' || (ifEnte && toApprove)">
      <v-row>
        <v-col cols="12" class="text-center">
          <v-btn class="mx-5" v-if="method !== 'VIEW' && (!ifEnte || !toApprove)" @click="saveAsdInfo" color="success">{{
            $t("save") }}</v-btn>
          <v-btn class="mx-5" v-if="ifEnte && toApprove" @click="saveAsdInfo" color="success">{{ $t("approve") }}</v-btn>
          <v-btn class="mx-5" v-if="ifEnte && toApprove" @click="rejectModify" color="error">{{ $t("reject") }}</v-btn>
        </v-col>
      </v-row>
    </template>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-row>
        <v-col v-if="isAffiliated" cols="12" class="text-center">
          <v-btn v-if="affiliationPdf" class="mx-5" @click="downloadAffiliationCert(asdInfo.code)"
            color="primary">{{ $t("downloadAffiliationCert") }}</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col v-if="toApprove" cols="12" class="text-center">
          <v-banner single-line>
            <v-icon slot="icon" color="warning" size="36">mdi-alert-outline</v-icon>
            <h2 class="warning--text">
              {{ $t("data_waiting_for_approvation") }}
            </h2>
          </v-banner>
        </v-col>
      </v-row>
      <v-container>
        <v-card outlined>
          <v-card-title>
            <v-icon slot="icon" color="primary" size="36">mdi-bank</v-icon>
            <h4 class="primary--text">{{ $t("company") }}</h4>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col md="2" cols="2">
                <v-text-field v-model="asdInfo.internalCode" :disabled="method === 'VIEW' || !ifEnte" maxlength="5"
                  :label="$t('code')" :rules="required" hide-details="auto"></v-text-field>
              </v-col> 
              <v-col :md="asdInfo.enteCode !== '' ? 1: 2" :disabled="method === 'VIEW' || !ifEnte" :cols="asdInfo.enteCode !== '' ? 1: 2" v-if="enabled && extEnteInfo.enabled">
                <v-text-field v-model="asdInfo.asdEnteCode" :disabled="true" maxlength="5"
                  :label="$t('code')+' '+asdInfo.enteCode" hide-details="auto"
                  ></v-text-field>
              </v-col>
              <v-col md="1" cols="1" v-if="enabled && extEnteInfo.enabled">
                 <v-select v-model="asdInfo.enteCode" :items="extEnteInfo.availExtEnteCode" item-text="dex" item-value="key"
                  :disabled="method === 'VIEW'" :label="$t('ente_code')" hide-details="auto"></v-select>
              </v-col>
              <v-col md="6" cols="6">
                <v-text-field v-model="asdInfo.ragSoc" :disabled="method === 'VIEW'" :label="$t('ragSoc')" :outlined="
                  asdOldVal && asdOldVal.ragSoc !== asdInfo.ragSoc
                    ? true
                    : false
                " :hint="
  asdOldVal && asdOldVal.ragSoc !== asdInfo.ragSoc
    ? $t('current_value') + ': ' + asdOldVal.ragSoc
    : ''
" :persistent-hint="
  asdOldVal && asdOldVal.ragSoc !== asdInfo.ragSoc
" :class="
  asdOldVal && asdOldVal.ragSoc !== asdInfo.ragSoc
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
" :rules="required" hide-details="auto"></v-text-field>
              </v-col>
              <v-col md="2" cols="12">
                <my-datepicker :disabled="method === 'VIEW'" :outlined="
                  asdOldVal &&
                    asdOldVal.dateCostituzione !== asdInfo.dateCostituzione
                    ? true
                    : false
                " :classe="
  asdOldVal &&
    asdOldVal.dateCostituzione !== asdInfo.dateCostituzione
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
" :hint="
  asdOldVal
    ? $t('current_value') +
    ': ' +
    new Date(asdOldVal.dateCostituzione).toLocaleDateString(
      'it'
    )
    : ''
" :persistentHint="
  asdOldVal &&
  asdOldVal.dateCostituzione !== asdInfo.dateCostituzione
" v-model="asdInfo.dateCostituzione" :label="$t('date_foundation')" :required="true" />
              </v-col>
              <v-col md="4" cols="12">
                <v-text-field v-model="asdInfo.respLegaleName" :disabled="method === 'VIEW'" :label="$t('resp_legal_name')"
                  :outlined="
                    asdOldVal && asdOldVal.respLegaleName !== asdInfo.respLegaleName
                      ? true
                      : false
                  " :hint="
  asdOldVal
    ? $t('current_value') + ': ' + asdOldVal.respLegaleName
    : ''
" :persistent-hint="
  asdOldVal && asdOldVal.respLegaleName !== asdInfo.respLegaleName
" :class="
  asdOldVal && asdOldVal.respLegaleName !== asdInfo.respLegaleName
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
" :rules="method !== 'ADD' ? required : notRequired" hide-details="auto"></v-text-field>
              </v-col>
              <v-col md="4" cols="12">
                <v-text-field v-model="asdInfo.respLegaleSurname" :disabled="method === 'VIEW'" :label="$t('resp_legal_surname')"
                  :outlined="
                    asdOldVal && asdOldVal.respLegaleSurname !== asdInfo.respLegaleSurname
                      ? true
                      : false
                  " :hint="
  asdOldVal
    ? $t('current_value') + ': ' + asdOldVal.respLegaleSurname
    : ''
" :persistent-hint="
  asdOldVal && asdOldVal.respLegaleSurname !== asdInfo.respLegaleSurname
" :class="
  asdOldVal && asdOldVal.respLegaleSurname !== asdInfo.respLegaleSurname
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
" :rules="method !== 'ADD' ? required : notRequired" hide-details="auto"></v-text-field>
              </v-col>
              <v-col md="4" cols="12">
                <v-text-field v-model="asdInfo.respLegaleCFisc" :disabled="method === 'VIEW'" :label="$t('resp_legal_cfisc')"
                  :outlined="
                    asdOldVal && asdOldVal.respLegaleCFisc !== asdInfo.respLegaleCFisc
                      ? true
                      : false
                  " :hint="
  asdOldVal
    ? $t('current_value') + ': ' + asdOldVal.respLegaleCFisc
    : ''
" :persistent-hint="
  asdOldVal && asdOldVal.respLegaleCFisc !== asdInfo.respLegaleCFisc
" :class="
  asdOldVal && asdOldVal.respLegaleCFisc !== asdInfo.respLegaleCFisc
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
" :rules="method !== 'ADD' ? required : notRequired" hide-details="auto"></v-text-field>
              </v-col>

              
            </v-row>
            <v-row>
              <v-col md="6" cols="12">
                <v-text-field v-model="asdInfo.nome" :rules="method !== 'ADD' ? required : notRequired"
                  :disabled="method === 'VIEW'" :label="$t('name')" :outlined="
                    asdOldVal && asdOldVal.nome !== asdInfo.nome ? true : false
                  " :hint="
  asdOldVal ? $t('current_value') + ': ' + asdOldVal.nome : ''
" :persistent-hint="
  asdOldVal && asdOldVal.nome !== asdInfo.nome
" :class="
  asdOldVal && asdOldVal.nome !== asdInfo.nome
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
" hide-details="auto"></v-text-field>
              </v-col>
              <v-col md="2" cols="12">
                <v-text-field v-model="asdInfo.cFiscale" :rules="method !== 'ADD' ? required : notRequired"
                  :disabled="method === 'VIEW'" :label="$t('fiscal_code')" :outlined="
                    asdOldVal && asdOldVal.cFiscale !== asdInfo.cFiscale
                      ? true
                      : false
                  " :hint="
  asdOldVal
    ? $t('current_value') + ': ' + asdOldVal.cFiscale
    : ''
" :persistent-hint="
  asdOldVal && asdOldVal.cFiscale !== asdInfo.cFiscale
" :class="
  asdOldVal && asdOldVal.cFiscale !== asdInfo.cFiscale
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
" hide-details="auto"></v-text-field>
              </v-col>
              <v-col md="2" cols="12">
                <v-text-field v-model="asdInfo.pIva" :disabled="method === 'VIEW'" :label="$t('pIva')" :outlined="
                  asdOldVal && asdOldVal.pIva !== asdInfo.pIva ? true : false
                " :hint="
  asdOldVal ? $t('current_value') + ': ' + asdOldVal.pIva : ''
" :persistent-hint="
  asdOldVal && asdOldVal.pIva !== asdInfo.pIva
" :class="
  asdOldVal && asdOldVal.pIva !== asdInfo.pIva
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
" hide-details="auto"></v-text-field>
              </v-col>
              <v-col md="2" cols="12">
                <v-text-field v-model="asdInfo.codiSoc" :disabled="method === 'VIEW' || !ifEnte"
                  :label="$t('code_society')" hide-details="auto"></v-text-field>

              </v-col>
            </v-row>
            <v-row>
              <v-col md="2" cols="4">
                <v-checkbox :disabled="method === 'VIEW'" :false-value="0" :true-value="1"
                  v-model="asdInfo.ifMonosportiva" :label="$t('monosport')" :color="
                    asdOldVal &&
                      asdOldVal.ifMonosportiva !== asdInfo.ifMonosportiva
                      ? 'warning'
                      : 'primary'
                  " :hint="
  asdOldVal
    ? $t('current_value') +
    ': ' +
    (asdOldVal.ifMonosportiva === 1 ? $t('yes') : $t('no'))
    : ''
" :persistentHint="
  asdOldVal &&
  asdOldVal.ifMonosportiva !== asdInfo.ifMonosportiva
"></v-checkbox>
              </v-col>
              <v-col md="2" cols="4">
                <v-checkbox :disabled="method === 'VIEW'" :false-value="0" :true-value="1" v-model="asdInfo.ifBAS"
                  :label="$t('BAS_society')" :color="
                    asdOldVal && asdOldVal.ifBAS !== asdInfo.ifBAS
                      ? 'warning'
                      : 'primary'
                  " :hint="
  asdOldVal
    ? $t('current_value') +
    ': ' +
    (asdOldVal.ifBAS === 1 ? $t('yes') : $t('no'))
    : ''
" :persistentHint="
  asdOldVal && asdOldVal.ifBAS !== asdInfo.ifBAS
"></v-checkbox>
              </v-col>
              <v-col md="2" cols="4">
                <v-checkbox :disabled="method === 'VIEW'" :false-value="0" :true-value="1" v-model="asdInfo.ifRegAPS"
                  :label="$t('if_reg_APS')" :color="
                    asdOldVal && asdOldVal.ifRegAPS !== asdInfo.ifRegAPS
                      ? 'warning'
                      : 'primary'
                  " :hint="
  asdOldVal
    ? $t('current_value') +
    ': ' +
    (asdOldVal.ifRegAPS === 1 ? $t('yes') : $t('no'))
    : ''
" :persistentHint="
  asdOldVal && asdOldVal.ifRegAPS !== asdInfo.ifRegAPS
"></v-checkbox>
              </v-col>
              <v-col :md="ifEnte ? 2 : 3" cols="12">
                <v-select v-model="asdInfo.meseInizioEsercizio" :items="listMesi" item-text="dex" item-value="key"
                  :disabled="method === 'VIEW'" :label="$t('month_start_exercise')" hide-details="auto"></v-select>
              </v-col>
              <v-col :md="ifEnte ? 2 : 3" cols="12">
                <v-select v-model="asdInfo.naturaGiuridica" :label="$t('legal_nature')"
                  :rules="method !== 'ADD' ? required : notRequired" :items="natureGiuridiche" item-text="Name"
                  item-value="Code" hide-details="auto" :outlined="
                    asdOldVal &&
                      asdOldVal.naturaGiuridica !== asdInfo.naturaGiuridica
                      ? true
                      : false
                  " :hint="
  asdOldVal
    ? $t('current_value') + ': ' + asdOldVal.naturaGiuridica
    : ''
" :persistent-hint="
  asdOldVal &&
  asdOldVal.naturaGiuridica !== asdInfo.naturaGiuridica
" :class="
  asdOldVal &&
    asdOldVal.naturaGiuridica !== asdInfo.naturaGiuridica
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
"></v-select>
              </v-col>
              <v-col v-if="ifEnte" md="2" cols="12">
                <v-select v-model="asdInfo.convenzione" :items="listConvenzioni" item-text="text" item-value="key"
                  :disabled="method === 'VIEW'" :label="$t('convention')" hide-details="auto"></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="4" cols="12">
                <v-text-field v-model="asdInfo.webSite" :disabled="method === 'VIEW'" :label="$t('website')" :outlined="
                  asdOldVal && asdOldVal.webSite !== asdInfo.webSite
                    ? true
                    : false
                " :hint="
  asdOldVal
    ? $t('current_value') + ': ' + asdOldVal.webSite
    : ''
" :persistent-hint="
  asdOldVal && asdOldVal.webSite !== asdInfo.webSite
" :class="
  asdOldVal && asdOldVal.webSite !== asdInfo.webSite
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
" hide-details="auto"></v-text-field>
              </v-col>
              <v-col md="4" cols="12">
                <v-text-field v-model="asdInfo.email" :disabled="method === 'VIEW'" :label="$t('email')" :outlined="
                  asdOldVal && asdOldVal.email !== asdInfo.email
                    ? true
                    : false
                " :hint="
  asdOldVal
    ? $t('current_value') + ': ' + asdOldVal.email
    : ''
" :persistent-hint="
  asdOldVal && asdOldVal.email !== asdInfo.email
" :class="
  asdOldVal && asdOldVal.email !== asdInfo.email
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
" hide-details="auto"></v-text-field>
              </v-col>
              <v-col md="4" cols="12">
                <v-text-field v-model="asdInfo.pec" :disabled="method === 'VIEW'" :label="$t('pec')" :outlined="
                  asdOldVal && asdOldVal.pec !== asdInfo.pec ? true : false
                " :hint="
  asdOldVal ? $t('current_value') + ': ' + asdOldVal.pec : ''
" :persistent-hint="asdOldVal && asdOldVal.pec !== asdInfo.pec" :class="
  asdOldVal && asdOldVal.pec !== asdInfo.pec
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
" hide-details="auto"></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="ifEnte">
              <v-col cols="12">
                <v-autocomplete v-model="asdInfo.userCanAcq" :items="listUsers" item-text="fullName" item-value="masterId"
                  :disabled="method === 'VIEW'" :menu-props="{ maxHeight: '400' }"
                  :label="$t('user_authorized_to_affiliate')" multiple chips color="primary" :hint="$t('select_users')"
                  persistent-hint></v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-autocomplete v-model="asdInfo.userCanAppEvent" :items="listUsers" item-text="fullName"
                  item-value="masterId" :disabled="method === 'VIEW'" :menu-props="{ maxHeight: '400' }"
                  :label="$t('user_authorized_to_approve_event')" multiple chips color="primary"
                  :hint="$t('select_users')" persistent-hint></v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-autocomplete v-model="asdInfo.userCanAppProduct" :items="listUsers" item-text="fullName"
                  item-value="masterId" :disabled="method === 'VIEW'" :menu-props="{ maxHeight: '400' }"
                  :label="$t('user_authorized_to_approve_product')" multiple chips color="primary"
                  :hint="$t('select_users')" persistent-hint></v-autocomplete>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
      <v-container>
        <v-card outlined>
          <v-card-title>
            <v-icon slot="icon" color="primary" size="36">mdi-basketball</v-icon>
            <h4 class="primary--text">{{ $t("disciplines") }}</h4>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-autocomplete v-model="asdInfo.discipline" :items="listDiscipline" item-text="descr"
                  item-value="idDisciplina" :disabled="method === 'VIEW'" :menu-props="{ maxHeight: '400' }"
                  :label="$t('pick_your_disciplines')" multiple chips color="primary" :hint="$t('pick_your_disciplines')"
                  persistent-hint></v-autocomplete>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
      <v-container>
        <v-card outlined>
          <v-card-title>
            <v-icon slot="icon" color="primary" size="36">mdi-account</v-icon>
            <h4 class="primary--text">{{ $t("ref_person") }}</h4>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col md="4" cols="12">
                <v-text-field v-model="asdInfo.refNome" :disabled="method === 'VIEW'" :label="$t('name')" :outlined="
                  asdOldVal && asdOldVal.refNome !== asdInfo.refNome
                    ? true
                    : false
                " :hint="
  asdOldVal
    ? $t('current_value') + ': ' + asdOldVal.refNome
    : ''
" :persistent-hint="
  asdOldVal && asdOldVal.refNome !== asdInfo.refNome
" :class="
  asdOldVal && asdOldVal.refNome !== asdInfo.refNome
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
" :rules="method !== 'ADD' ? required : notRequired" hide-details="auto"></v-text-field>
              </v-col>
              <v-col md="4" cols="12">
                <v-text-field v-model="asdInfo.refTel" :disabled="method === 'VIEW'" :label="$t('telephone')" :outlined="
                  asdOldVal && asdOldVal.refTel !== asdInfo.refTel
                    ? true
                    : false
                " :hint="
  asdOldVal
    ? $t('current_value') + ': ' + asdOldVal.refTel
    : ''
" :persistent-hint="
  asdOldVal && asdOldVal.refTel !== asdInfo.refTel
" :class="
  asdOldVal && asdOldVal.refTel !== asdInfo.refTel
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
" :rules="method !== 'ADD' ? required : notRequired" hide-details="auto"></v-text-field>
              </v-col>
              <v-col md="4" cols="12">
                <v-text-field v-model="asdInfo.refEmail" :disabled="method === 'VIEW'" :label="$t('email')" :outlined="
                  asdOldVal && asdOldVal.refEmail !== asdInfo.refEmail
                    ? true
                    : false
                " :hint="
  asdOldVal
    ? $t('current_value') + ': ' + asdOldVal.refEmail
    : ''
" :persistent-hint="
  asdOldVal && asdOldVal.refEmail !== asdInfo.refEmail
" :class="
  asdOldVal && asdOldVal.refEmail !== asdInfo.refEmail
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
" :rules="method !== 'ADD' ? required : notRequired" hide-details="auto"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
      <v-container>
        <v-card outlined>
          <v-card-title>
            <v-icon slot="icon" color="primary" size="36">mdi-email-multiple-outline</v-icon>
            <h4 class="primary--text">{{ $t("postal_recap") }}</h4>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col md="6" cols="12">
                <v-text-field v-model="asdInfo.recPostRagSoc" :disabled="method === 'VIEW'" :label="$t('ragSoc')"
                  :outlined="
                    asdOldVal &&
                      asdOldVal.recPostRagSoc !== asdInfo.recPostRagSoc
                      ? true
                      : false
                  " :hint="
  asdOldVal
    ? $t('current_value') + ': ' + asdOldVal.recPostRagSoc
    : ''
" :persistent-hint="
  asdOldVal &&
  asdOldVal.recPostRagSoc !== asdInfo.recPostRagSoc
" :class="
  asdOldVal &&
    asdOldVal.recPostRagSoc !== asdInfo.recPostRagSoc
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
" :rules="method !== 'ADD' ? required : notRequired" hide-details="auto"></v-text-field>
              </v-col>
              <v-col md="6" cols="12">
                <v-text-field v-model="asdInfo.recPostLocalita" :disabled="method === 'VIEW'" :label="$t('location')"
                  :outlined="
                    asdOldVal &&
                      asdOldVal.recPostLocalita !== asdInfo.recPostLocalita
                      ? true
                      : false
                  " :hint="
  asdOldVal
    ? $t('current_value') + ': ' + asdOldVal.recPostLocalita
    : ''
" :persistent-hint="
  asdOldVal &&
  asdOldVal.recPostLocalita !== asdInfo.recPostLocalita
" :class="
  asdOldVal &&
    asdOldVal.recPostLocalita !== asdInfo.recPostLocalita
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
" :rules="method !== 'ADD' ? required : notRequired" hide-details="auto"></v-text-field>
              </v-col>
              <v-col md="8" cols="12">
                <v-text-field v-model="asdInfo.recPostIndirizzo" :disabled="method === 'VIEW'" :label="$t('address')"
                  :outlined="
                    asdOldVal &&
                      asdOldVal.recPostIndirizzo !== asdInfo.recPostIndirizzo
                      ? true
                      : false
                  " :hint="
  asdOldVal
    ? $t('address') + ': ' + asdOldVal.recPostIndirizzo
    : ''
" :persistent-hint="
  asdOldVal &&
  asdOldVal.recPostIndirizzo !== asdInfo.recPostIndirizzo
" :class="
  asdOldVal &&
    asdOldVal.recPostIndirizzo !== asdInfo.recPostIndirizzo
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
" :rules="method !== 'ADD' ? required : notRequired" hide-details="auto"></v-text-field>
              </v-col>
              <v-col md="2" cols="6">
                <v-text-field v-model="asdInfo.recPostProv" :disabled="method === 'VIEW'" :label="$t('province')"
                  :outlined="
                    asdOldVal && asdOldVal.recPostProv !== asdInfo.recPostProv
                      ? true
                      : false
                  " :hint="
  asdOldVal
    ? $t('current_value') + ': ' + asdOldVal.recPostProv
    : ''
" :persistent-hint="
  asdOldVal && asdOldVal.recPostProv !== asdInfo.recPostProv
" :class="
  asdOldVal && asdOldVal.recPostProv !== asdInfo.recPostProv
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
" :rules="method !== 'ADD' ? required : notRequired" hide-details="auto"></v-text-field>
              </v-col>
              <v-col md="2" cols="6">
                <v-text-field v-model="asdInfo.recPostCAP" :disabled="method === 'VIEW'" :label="$t('postal_code')"
                  :outlined="
                    asdOldVal && asdOldVal.recPostCAP !== asdInfo.recPostCAP
                      ? true
                      : false
                  " :hint="
  asdOldVal
    ? $t('current_value') + ': ' + asdOldVal.recPostCAP
    : ''
" :persistent-hint="
  asdOldVal && asdOldVal.recPostCAP !== asdInfo.recPostCAP
" :class="
  asdOldVal && asdOldVal.recPostCAP !== asdInfo.recPostCAP
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
" :rules="method !== 'ADD' ? required : notRequired" hide-details="auto"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
      <v-container>
        <v-card outlined>
          <v-card-title>
            <v-icon slot="icon" color="primary" size="36">mdi-cash</v-icon>
            <h4 class="primary--text">{{ $t("fiscal_recap") }}</h4>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col md="6" cols="12">
                <v-text-field prepend-icon="mdi-content-copy" @click:prepend="copy('fiscal')"
                  v-model="asdInfo.recFiscRagSoc" :disabled="method === 'VIEW'" :label="$t('ragSoc')" :outlined="
                    asdOldVal &&
                      asdOldVal.recFiscRagSoc !== asdInfo.recFiscRagSoc
                      ? true
                      : false
                  " :hint="
  asdOldVal
    ? $t('current_value') + ': ' + asdOldVal.recFiscRagSoc
    : ''
" :persistent-hint="
  asdOldVal &&
  asdOldVal.recFiscRagSoc !== asdInfo.recFiscRagSoc
" :class="
  asdOldVal &&
    asdOldVal.recFiscRagSoc !== asdInfo.recFiscRagSoc
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
" :rules="method !== 'ADD' ? required : notRequired" hide-details="auto"></v-text-field>
              </v-col>
              <v-col md="6" cols="12">
                <v-text-field v-model="asdInfo.recFiscLocalita" :disabled="method === 'VIEW'" :label="$t('location')"
                  :outlined="
                    asdOldVal &&
                      asdOldVal.recFiscLocalita !== asdInfo.recFiscLocalita
                      ? true
                      : false
                  " :hint="
  asdOldVal
    ? $t('current_value') + ': ' + asdOldVal.recFiscLocalita
    : ''
" :persistent-hint="
  asdOldVal &&
  asdOldVal.recFiscLocalita !== asdInfo.recFiscLocalita
" :class="
  asdOldVal &&
    asdOldVal.recFiscLocalita !== asdInfo.recFiscLocalita
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
" :rules="method !== 'ADD' ? required : notRequired" hide-details="auto"></v-text-field>
              </v-col>
              <v-col md="8" cols="12">
                <v-text-field v-model="asdInfo.recFiscIndirizzo" :disabled="method === 'VIEW'" :label="$t('address')"
                  :outlined="
                    asdOldVal &&
                      asdOldVal.recFiscIndirizzo !== asdInfo.recFiscIndirizzo
                      ? true
                      : false
                  " :hint="
  asdOldVal
    ? $t('address') + ': ' + asdOldVal.recFiscIndirizzo
    : ''
" :persistent-hint="
  asdOldVal &&
  asdOldVal.recFiscIndirizzo !== asdInfo.recFiscIndirizzo
" :class="
  asdOldVal &&
    asdOldVal.recFiscIndirizzo !== asdInfo.recFiscIndirizzo
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
" :rules="method !== 'ADD' ? required : notRequired" hide-details="auto"></v-text-field>
              </v-col>
              <v-col md="2" cols="6">
                <v-text-field v-model="asdInfo.recFiscProv" :disabled="method === 'VIEW'" :label="$t('province')"
                  :outlined="
                    asdOldVal && asdOldVal.recFiscProv !== asdInfo.recFiscProv
                      ? true
                      : false
                  " :hint="
  asdOldVal
    ? $t('current_value') + ': ' + asdOldVal.recFiscProv
    : ''
" :persistent-hint="
  asdOldVal && asdOldVal.recFiscProv !== asdInfo.recFiscProv
" :class="
  asdOldVal && asdOldVal.recFiscProv !== asdInfo.recFiscProv
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
" :rules="method !== 'ADD' ? required : notRequired" hide-details="auto"></v-text-field>
              </v-col>
              <v-col md="2" cols="6">
                <v-text-field v-model="asdInfo.recFiscCAP" :disabled="method === 'VIEW'" :label="$t('postal_code')"
                  :outlined="
                    asdOldVal && asdOldVal.recFiscCAP !== asdInfo.recFiscCAP
                      ? true
                      : false
                  " :hint="
  asdOldVal
    ? $t('current_value') + ': ' + asdOldVal.recFiscCAP
    : ''
" :persistent-hint="
  asdOldVal && asdOldVal.recFiscCAP !== asdInfo.recFiscCAP
" :class="
  asdOldVal && asdOldVal.recFiscCAP !== asdInfo.recFiscCAP
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
" :rules="method !== 'ADD' ? required : notRequired" hide-details="auto"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>

      <v-container>
        <v-card outlined>
          <v-card-title>
            <v-icon slot="icon" color="primary" size="36">mdi-gavel</v-icon>
            <h4 class="primary--text">{{ $t("legal_recap") }}</h4>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col md="6" cols="12">
                <v-text-field prepend-icon="mdi-content-copy" @click:prepend="copy('legal')"
                  v-model="asdInfo.sedLegRagSoc" :disabled="method === 'VIEW'" :label="$t('ragSoc')" :outlined="
                    asdOldVal && asdOldVal.sedLegRagSoc !== asdInfo.sedLegRagSoc
                      ? true
                      : false
                  " :hint="
  asdOldVal
    ? $t('current_value') + ': ' + asdOldVal.sedLegRagSoc
    : ''
" :persistent-hint="
  asdOldVal && asdOldVal.sedLegRagSoc !== asdInfo.sedLegRagSoc
" :class="
  asdOldVal && asdOldVal.sedLegRagSoc !== asdInfo.sedLegRagSoc
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
" :rules="method !== 'ADD' ? required : notRequired" hide-details="auto"></v-text-field>
              </v-col>
              <v-col md="6" cols="12">
                <v-text-field v-model="asdInfo.sedLegLocalita" :disabled="method === 'VIEW'" :label="$t('location')"
                  :outlined="
                    asdOldVal &&
                      asdOldVal.sedLegLocalita !== asdInfo.sedLegLocalita
                      ? true
                      : false
                  " :hint="
  asdOldVal
    ? $t('current_value') + ': ' + asdOldVal.sedLegLocalita
    : ''
" :persistent-hint="
  asdOldVal &&
  asdOldVal.sedLegLocalita !== asdInfo.sedLegLocalita
" :class="
  asdOldVal &&
    asdOldVal.sedLegLocalita !== asdInfo.sedLegLocalita
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
" :rules="method !== 'ADD' ? required : notRequired" hide-details="auto"></v-text-field>
              </v-col>
              <v-col md="8" cols="12">
                <v-text-field v-model="asdInfo.sedLegIndirizzo" :disabled="method === 'VIEW'" :label="$t('address')"
                  :outlined="
                    asdOldVal &&
                      asdOldVal.sedLegIndirizzo !== asdInfo.sedLegIndirizzo
                      ? true
                      : false
                  " :hint="
  asdOldVal
    ? $t('address') + ': ' + asdOldVal.sedLegIndirizzo
    : ''
" :persistent-hint="
  asdOldVal &&
  asdOldVal.sedLegIndirizzo !== asdInfo.sedLegIndirizzo
" :class="
  asdOldVal &&
    asdOldVal.sedLegIndirizzo !== asdInfo.sedLegIndirizzo
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
" :rules="method !== 'ADD' ? required : notRequired" hide-details="auto"></v-text-field>
              </v-col>

              <v-col md="2" cols="6">
                <v-text-field v-model="asdInfo.sedLegProv" :disabled="method === 'VIEW'" :label="$t('province')"
                  :outlined="
                    asdOldVal && asdOldVal.sedLegProv !== asdInfo.sedLegProv
                      ? true
                      : false
                  " :hint="
  asdOldVal
    ? $t('current_value') + ': ' + asdOldVal.sedLegProv
    : ''
" :persistent-hint="
  asdOldVal && asdOldVal.sedLegProv !== asdInfo.sedLegProv
" :class="
  asdOldVal && asdOldVal.sedLegProv !== asdInfo.sedLegProv
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
" :rules="method !== 'ADD' ? required : notRequired" hide-details="auto"></v-text-field>
              </v-col>
              <v-col md="2" cols="6">
                <v-text-field v-model="asdInfo.sedLegCAP" :disabled="method === 'VIEW'" :label="$t('postal_code')"
                  :outlined="
                    asdOldVal && asdOldVal.sedLegCAP !== asdInfo.sedLegCAP
                      ? true
                      : false
                  " :hint="
  asdOldVal
    ? $t('current_value') + ': ' + asdOldVal.sedLegCAP
    : ''
" :persistent-hint="
  asdOldVal && asdOldVal.sedLegCAP !== asdInfo.sedLegCAP
" :class="
  asdOldVal && asdOldVal.sedLegCAP !== asdInfo.sedLegCAP
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
" :rules="method !== 'ADD' ? required : notRequired" hide-details="auto"></v-text-field>
              </v-col>

              <v-col md="3" cols="6">
                <v-text-field v-model="asdInfo.sedLegTel" :disabled="method === 'VIEW'" :label="$t('telephone')"
                  :outlined="
                    asdOldVal && asdOldVal.sedLegTel !== asdInfo.sedLegTel
                      ? true
                      : false
                  " :hint="
  asdOldVal
    ? $t('current_value') + ': ' + asdOldVal.sedLegTel
    : ''
" :persistent-hint="
  asdOldVal && asdOldVal.sedLegTel !== asdInfo.sedLegTel
" :class="
  asdOldVal && asdOldVal.sedLegTel !== asdInfo.sedLegTel
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
" hide-details="auto"></v-text-field>
              </v-col>
              <v-col md="3" cols="6">
                <v-text-field v-model="asdInfo.sedLegEmail" :disabled="method === 'VIEW'" :label="$t('email')" :outlined="
                  asdOldVal && asdOldVal.sedLegEmail !== asdInfo.sedLegEmail
                    ? true
                    : false
                " :hint="
  asdOldVal
    ? $t('current_value') + ': ' + asdOldVal.sedLegEmail
    : ''
" :persistent-hint="
  asdOldVal && asdOldVal.sedLegEmail !== asdInfo.sedLegEmail
" :class="
  asdOldVal && asdOldVal.sedLegEmail !== asdInfo.sedLegEmail
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
" hide-details="auto"></v-text-field>
              </v-col>
              <v-col md="3" cols="6">
                <v-text-field v-model="asdInfo.sedLegFax" :disabled="method === 'VIEW'" :label="$t('fax')" :outlined="
                  asdOldVal && asdOldVal.sedLegFax !== asdInfo.sedLegFax
                    ? true
                    : false
                " :hint="
  asdOldVal
    ? $t('current_value') + ': ' + asdOldVal.sedLegFax
    : ''
" :persistent-hint="
  asdOldVal && asdOldVal.sedLegFax !== asdInfo.sedLegFax
" :class="
  asdOldVal && asdOldVal.sedLegFax !== asdInfo.sedLegFax
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
" hide-details="auto"></v-text-field>
              </v-col>
              <v-col md="3" cols="6">
                <v-text-field v-model="asdInfo.sedLegMobile" :disabled="method === 'VIEW'" :label="$t('telephone_mobile')"
                  :outlined="
                    asdOldVal && asdOldVal.sedLegMobile !== asdInfo.sedLegMobile
                      ? true
                      : false
                  " :hint="
  asdOldVal
    ? $t('current_value') + ': ' + asdOldVal.sedLegMobile
    : ''
" :persistent-hint="
  asdOldVal && asdOldVal.sedLegMobile !== asdInfo.sedLegMobile
" :class="
  asdOldVal && asdOldVal.sedLegMobile !== asdInfo.sedLegMobile
    ? 'v-input--is-focused warning--text input-group--focused'
    : ''
" hide-details="auto"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </base-dialog-form>
</template>
<script>
import Swal from "sweetalert2";
import MyDatepicker from "@/components/base/MyDatepicker.vue";

export default {
  name: "edit-associazione",
  props: {
    parmsMethod: null,
    parmsAsdCode: null,
    type: {
      type: String, // not 'string'
      required: false,
      default: "dialog",
    },
  },
  components: {
    MyDatepicker,
  },
  computed: {
    computedTitle: function () {
      if (this.method === "EDIT" && this.ifEnte && this.toApprove)
        return this.$t("review_association") + " " + this.code;
      else if (this.method === "EDIT" && (!this.ifEnte || !this.toApprove))
        return this.$t("view_association") + " " + this.code;
      else if (this.method === "VIEW")
        return this.$t("view_association") + " " + this.code;
      else if (this.method === "ADD") return this.$t("create_association");
      else return "";
    },
  },
  data() {
    return {
      method: null,
      code: null,
      orderId: null,
      RBAC_PARTIAL_COMPILE_ASD_INFO: false,
      listConvenzioni: [],
      natureGiuridiche: [],
      listDiscipline: [],
      listMesi: [
        { key: 1, dex: this.$t("january") },
        { key: 2, dex: this.$t("february") },
        { key: 3, dex: this.$t("march") },
        { key: 4, dex: this.$t("april") },
        { key: 5, dex: this.$t("may") },
        { key: 6, dex: this.$t("june") },
        { key: 7, dex: this.$t("july") },
        { key: 8, dex: this.$t("august") },
        { key: 9, dex: this.$t("september") },
        { key: 10, dex: this.$t("october") },
        { key: 11, dex: this.$t("november") },
        { key: 12, dex: this.$t("december") },
      ],
      listUsers: [],
      valid: false,
      ifEnte: false,
      isAffiliated: false,
      affiliationPdf: false,
      affiliationOrder: null,
      asdInfo: {},
      extEnteInfo: false,
      asdOldVal: null,
      enabled: null,
      toApprove: null,
      notRequired: [(value) => true],
      required: [(value) => !!value || this.$t("required_field")],
      requiredNumber: [
        (value) => (!!value && !isNaN(value)) || this.$t("required_field"),
      ],
    };
  },
  methods: {
    open(method, code) {
      if (method === "PORTAL_REQUEST") {
        this.method = "ADD";
        this.orderId = code;
        this.code = null;
      } else {
        this.method = method;
        this.code = code;
        this.orderId = null;
      }
      this.loadData();
      this.$refs.editAssociazioneDialog.open();
    },
    downloadAffiliationCert(asdCode) {
      let url = "/auth/ente/pdf/downloadAffiliationCert/" + asdCode;
      url = this.authorizeLink(url);
      window.open(url);
    },
    loadData() {
      let _ = this;

      _.ifEnte = false;
      _.natureGiuridiche = window.systemData.natureGiuridiche;
      _.asdInfo = {};
      _.extEnteInfo = false;
      _.asdOldVal = null;
      _.enabled = false;
      _.toApprove = false;
      _.isAffiliated = false;
      _.affiliationPdf = false;
      _.affiliationOrder = null;
      _.listUsers = [];
      if (_.method !== "ADD" || _.orderId) {
        let url = "/auth/ente/getAsdInfo";
        if (_.code) url = "/auth/ente/getAsdInfo/" + _.code;
        if (_.orderId) url = "/auth/ente/getAsdRequest/" + _.orderId;
        _.chiamataAxios("GET", url).then((response) => {
          _.asdInfo = response.data.data;
          _.extEnteInfo =response.data.extEnteInfo
          _.isAffiliated = response.data.isAffiliated;
          _.affiliationPdf = response.data.affiliationPdf;
          _.affiliationOrder = response.data.isAffiliated
            ? response.data.affiliationOrder
            : null;
          _.ifEnte = response.data.ifEnte;
          _.asdOldVal = response.data.confirmedVal;
          _.enabled = response.data.enabled;
          _.toApprove = response.data.toApprove;

          if (_.ifEnte) {
            _.chiamataAxios("POST", "/auth/portal/listUsers").then(
              (response) => {
                _.listUsers = response.data;
              }
            );
          }
        });
      } else {
        _.asdInfo.dateCostituzione = new Date();
        _.ifEnte = true;
      }
      _.listConvenzioni = [];
      if (window.systemData.ifEnte) {
        _.chiamataAxios("POST", "/auth/ente/listConvenzioni").then(
          (response) => {
            _.listConvenzioni = response.data;
          }
        );
      }
      _.listDiscipline = [];
      _.chiamataAxios("GET", "/auth/ente/listAllDiscipline").then(
        (response) => {
          _.listDiscipline = response.data;
        }
      );
    },

    rejectModify(item) {
      let _ = this;
      Swal.fire({
        title: this.$t("are_you_sure_?"),
        text: this.$t("you_cant_revert_this"),
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: this.$t("yes_reject"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          _.chiamataAxios("DELETE", "/auth/ente/rejectAsdChange/" + _.code, {
            dialogLoader: true,
          }).then((response) => {
            if (response.msg.esito) {
              let html = "<strong>" + response.msg.msgTxt + "</strong>"
              Swal.fire({
                type: "success",
                html: html,
              });
              _.loadData();
              _.$emit("isUpdated", "true");
            }
          });
        }
      });
    },
    copy(mode) {
      let _ = this;
      switch (mode) {
        case "fiscal":
          _.asdInfo.recFiscRagSoc = _.asdInfo.recPostRagSoc;
          _.asdInfo.recFiscLocalita = _.asdInfo.recPostLocalita;
          _.asdInfo.recFiscProv = _.asdInfo.recPostProv;
          _.asdInfo.recFiscIndirizzo = _.asdInfo.recPostIndirizzo;
          _.asdInfo.recFiscCAP = _.asdInfo.recPostCAP;
          break;
        case "legal":
          _.asdInfo.sedLegRagSoc = _.asdInfo.recFiscRagSoc;
          _.asdInfo.sedLegLocalita = _.asdInfo.recFiscLocalita;
          _.asdInfo.sedLegProv = _.asdInfo.recFiscProv;
          _.asdInfo.sedLegIndirizzo = _.asdInfo.recFiscIndirizzo;
          _.asdInfo.sedLegCAP = _.asdInfo.recFiscCAP;
          break;
      }
    },
    saveAsdInfo: function () {
      let _ = this;
      let esito = this.$refs.form.validate();
      let mandatoryComplete =
        _.asdInfo.ragSoc !== "" &&
        _.asdInfo.respLegaleName !== "" &&
        _.asdInfo.respLegaleSurname !== "" &&
        _.asdInfo.respLegaleCFisc !== "" &&
        _.asdInfo.nome !== "" &&
        _.asdInfo.cFiscale !== "";
      if (esito || (_.RBAC_PARTIAL_COMPILE_ASD_INFO && mandatoryComplete)) {
        let asdInfoData = {
          internalCode: _.asdInfo.internalCode,
          ragSoc: _.asdInfo.ragSoc,
          dateCostituzione: _.asdInfo.dateCostituzione,
          nome: _.asdInfo.nome,
          respLegaleName: _.asdInfo.respLegaleName,
          respLegaleSurname: _.asdInfo.respLegaleSurname,
          respLegaleCFisc: _.asdInfo.respLegaleCFisc,
          ifMonosportiva: _.asdInfo.ifMonosportiva,
          ifBAS: _.asdInfo.ifBAS,
          ifRegAPS: _.asdInfo.ifRegAPS,
          naturaGiuridica: _.asdInfo.naturaGiuridica,
          meseInizioEsercizio: _.asdInfo.meseInizioEsercizio,
          refNome: _.asdInfo.refNome,
          refTel: _.asdInfo.refTel,
          refEmail: _.asdInfo.refEmail,
          email: _.asdInfo.email,
          pec: _.asdInfo.pec,
          enteCode: _.asdInfo.enteCode,
          asdEnteCode: _.asdInfo.asdEnteCode,
          cFiscale: _.asdInfo.cFiscale,
          pIva: _.asdInfo.pIva,
          webSite: _.asdInfo.webSite,
          facebook: _.asdInfo.facebook,
          convenzione: _.asdInfo.convenzione,
          codiSoc: _.asdInfo.codiSoc,
          sedLegRagSoc: _.asdInfo.sedLegRagSoc,
          sedLegLocalita: _.asdInfo.sedLegLocalita,
          sedLegProv: _.asdInfo.sedLegProv,
          sedLegIndirizzo: _.asdInfo.sedLegIndirizzo,
          sedLegCAP: _.asdInfo.sedLegCAP,
          sedLegTel: _.asdInfo.sedLegTel,
          sedLegEmail: _.asdInfo.sedLegEmail,
          sedLegFax: _.asdInfo.sedLegFax,
          sedLegMobile: _.asdInfo.sedLegMobile,
          recPostRagSoc: _.asdInfo.recPostRagSoc,
          recPostLocalita: _.asdInfo.recPostLocalita,
          recPostIndirizzo: _.asdInfo.recPostIndirizzo,
          recPostCAP: _.asdInfo.recPostCAP,
          recFiscRagSoc: _.asdInfo.recFiscRagSoc,
          recFiscLocalita: _.asdInfo.recFiscLocalita,
          recFiscProv: _.asdInfo.recFiscProv,
          recFiscIndirizzo: _.asdInfo.recFiscIndirizzo,
          recFiscCAP: _.asdInfo.recFiscCAP,
          recPostProv: _.asdInfo.recPostProv,
          userCanAcq: _.asdInfo.userCanAcq,
          userCanAppEvent: _.asdInfo.userCanAppEvent,
          userCanAppProduct: _.asdInfo.userCanAppProduct,
          discipline: _.asdInfo.discipline,
        };
        let url =
          _.method === "ADD"
            ? "/auth/ente/createAsdWithNoPortal/" + _.asdInfo.code
            : "/auth/ente/saveAsdInfo/" + _.code;
        if (_.orderId) url += "/" + _.orderId;
        _.chiamataAxios("PUT", url, {
          dialogLoader: true,
          msg: "always",
          body: asdInfoData,
        }).then((response) => {
          if (response.msg.esito) {
            _.$refs.editAssociazioneDialog.close();
            _.loadData();
            _.$emit("isUpdated", "true");
          }
        });
      }
    },
  },
  created() {
    this.RBAC_PARTIAL_COMPILE_ASD_INFO = this.checkUserRole(
      "ente",
      "PARTIAL_COMPILE_ASD_INFO"
    );
  },
  mounted() {
    if (this.parmsAsdCode) this.code = this.parmsAsdCode;
    if (this.parmsMethod) this.method = this.parmsMethod;
    this.loadData();
  },
  watch: {
    parmsAsdCode: function (newVal, oldVal) {
      // watch it
      if (newVal) this.code = newVal;
    },
    code: function (newVal, oldVal) {
      // watch it
      this.loadData();
    },
    parmsMethod: function (newVal, oldVal) {
      // watch it
      if (newVal) this.method = newVal;
    },
  },
};
</script>